import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AiService } from 'src/app/business-service/ai/ai.service';

@Component({
  selector: 'app-personalized-itinerary-form',
  templateUrl: './personalized-itinerary-form.component.html',
  styleUrls: ['./personalized-itinerary-form.component.scss'],
})
export class PersonalizedItineraryFormComponent implements OnInit {

  itineraryForm!: FormGroup;

  destinations = ['Hyderabad', 'Bhadrachalam', 'Yadagirigutta', 'Basara', 'Kuntala Water Falls', 'Nagarjuna Sagar', 'Warangal', 'Ramappa Temple'];
  interests = ['Spiritual', 'Nature', 'Adventure', 'Heritage', 'Educational', 'Leisure', 'Wellness'];
  accessibilityToggle = ['Wheelchair-friendly', 'Low-walking', 'Seniorfriendly'];
  foodPreferences = ['Veg Only', 'Veg+NonVeg', 'Vegan'];
  seasons = ['Avoid heat', 'Comfortable', 'Any'];
  paceList = ['Active', 'Relaxed', 'Moderate'];

  constructor(private fb: FormBuilder, private aiService: AiService) { }

  ngOnInit(): void {
    this.itineraryForm = this.fb.group({
      days: [3],
      nights: [4],
      destination: [[]],
      interests: [[]],
      accessibilityToggle: ['Low-walking'],
      foodPreferences: ['Veg+NonVeg'],
      seasonPreferences: [[]],
      pace: ['Active']
    });
  }

  onSubmit() {
    console.log('Itinerary Input Payload:', this.itineraryForm.value);

    this.aiService.getPiAiGeneratedRouteCraftJson(this.itineraryForm.value).subscribe((data) => {
      console.log(data);
    })
  }
}
